import { type ReactNode } from 'react'
import {
  isNotDefined,
  type DashboardWidget,
} from '@terros/common'
import { SegmentedControl } from '@mantine/core'
import { getSelectedReportColumnDisplayLabel, useReportColumnsMetadata } from '@front/model'

type Props = {
  metricIndex: number
  widget: Extract<DashboardWidget, { type: 'leaderboard' }>
  onMetricIndexChange: (metricIndex: number) => void
}

export function LeaderboardMetricSelector({ metricIndex, widget, onMetricIndexChange }: Props): ReactNode {
  const { columnsMap, data: reportColumns, variantMap } = useReportColumnsMetadata()

  if (isNotDefined(reportColumns) || widget.metrics.length < 2) return undefined

  const selectedColumns = new Set(widget.metrics.map((metric) => metric.kpi))

  return (
    <div className='max-w-[60%] overflow-x-auto'>
      <SegmentedControl
        color='brand'
        data={widget.metrics.map((metric, index) => ({
          label: getSelectedReportColumnDisplayLabel({
            value: metric.kpi,
            selectedColumns,
            columnsMap,
            variantMap,
          }),
          value: String(index),
        }))}
        size='xs'
        style={{ minWidth: 'max-content' }}
        value={String(metricIndex)}
        onChange={(value) => onMetricIndexChange(Number(value))}
      />
    </div>
  )
}
